<div class="uploadPODialog">
    <!-- [closeOnEscape]="disableSave" -->
    <p-dialog header="Upload Document(s)" [(visible)]="displayUploadPODialog" [modal]="true" showEffect="fade"
        (onHide)="hideUploadPODialog()" [closable]="!disableSave" [closeOnEscape]="false" [width]="1100"
        (onShow)="showUploadPODialog()" class="dialogImageUpload">
        <div *ngIf="isLoading">
            <div class="loading">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>
        <div>
            <!-- <fieldset> -->
            <!-- <legend> -->
            <p-fileUpload #fileRef mode="basic" [chooseLabel]="'ADD DOCUMENT'" [maxFileSize]="1000000" name="demo[]"
                accept="*" (onSelect)="onFileSelection($event)" pTooltip="{{files.length}} file(s) selected" title=" "
                [auto]="true"></p-fileUpload>
            <!-- </legend> -->
            <form #uploadPoForm="ngForm" autocomplete="off">
                <div class="padding-10 margin-top-10 ui-g-12 card bg-color outer-card-vertical-scroller">
                    <div class="unorderedList ui-g padding-5 ui-g-4"
                        *ngFor="let po of purchaseOrdersWrapper; let i=index">
                        <div class="ui-g-11 card inner-card-vertical-scroller">
                            <!-- <div class="ui-g-2 padding-0">
                                <div class="margin-top-3 padding-left-20">
                                    <span class="ui-g-1 padding-0">
                                        {{i + 1}}.
                                    </span>
                                    <span class="ui-g-11 word-break-wrap padding-0">
                                        {{po.purchaseOrder.name}}
                                    </span>
                                </div>
                            </div> -->
                            <div class="ui-g padding-0">
                                <div class="ui-g-11 word-break-wrap padding-0 po-name">
                                    {{po.purchaseOrder.name}}
                                </div>
                                <div class="ui-g-1 padding-0">
                                    <i class="fa fa-trash-o info-red" title="Remove the file" aria-hidden="true"
                                        (click)="removeFile(i)"></i>
                                </div>
                            </div>
                            <!-- Raveena | 20-05-2019 Removed extension change in po name -->
                            <!-- (blur)="changeName($event, i)" -->
                            <div class="ui-g padding-top-10">
                                <div class="ui-g-9 setInput padding-left-0">
                                    <span class="md-inputfield">
                                        <input #name="ngModel" id="name" type="text" trim="blur"
                                            [(ngModel)]="po.newName" [disabled]="disableSave" autocomplete="off"
                                            pInputText name="newName{{i}}" title=" " />
                                        <label for="newName">New Name</label>
                                    </span>
                                </div>
                                <div class="ui-g-3 padding-0">
                                    <p-checkbox name="po{{i}}" binary="true" label="IS PO?" inputId="po{{i}}"
                                        (onChange)="onCheckboxSelectionChange($event, i)"
                                        [(ngModel)]="po.purchaseOrder.po"></p-checkbox>
                                </div>
                            </div>
                            <!-- <div class="ui-g-2 padding-0 setInput">
                                <span class="md-inputfield">
                                    <input #name="ngModel" id="name" type="text" trim="blur" [(ngModel)]="po.newName"
                                        (blur)="changeName($event, i)" autocomplete="off" pInputText name="newName{{i}}"
                                        title=" " />
                                    <label for="newName">New Name</label>
                                </span>
                            </div> -->
                            <!-- <div class="ui-g-1 padding-0">
                                <p-checkbox name="po{[i}}" binary="true" label="IS PO?" inputId="po" [(ngModel)]="po.purchaseOrder.po"></p-checkbox>
                            </div> -->
                            <div class="ui-g padding-top-10">
                                <div class="ui-g-6 setInput padding-left-0">
                                    <span class="md-inputfield">
                                        <input #poNumber="ngModel" id="poNumber" type="text" trim="blur"
                                            [(ngModel)]="po.purchaseOrder.poNumber" [disabled]="!po.purchaseOrder.po"
                                            pInputText name="poNumber{{i}}" maxlength="50" title=" " required />
                                        <label for="poNumber">PO Number
                                            <span class="required">*</span>
                                        </label>
                                    </span>
                                </div>
                                <div class="ui-g-6">
                                    <span class="ui-float-label">
                                        <p-calendar [inputStyle]="{'width':'90%'}" #poDate="ngModel" id="poDate"
                                            name="poDate{{i}}" [disabled]="!po.purchaseOrder.po" showIcon="true"
                                            [utc]="true" [(ngModel)]="po.purchaseOrder.poDate" dateFormat="ddMy"
                                            trim="blur" monthNavigator="true" yearNavigator="true"
                                            [yearRange]="'2017:2050'" required appendTo="body"></p-calendar>
                                        <label for="endDate">PO Date
                                            <span class="required">*</span>
                                        </label>
                                    </span>
                                </div>
                            </div>
                            <!-- <div class="ui-g-2 padding-0 setInput">
                                <span class="md-inputfield">
                                    <input #poNumber="ngModel" id="poNumber" type="text" trim="blur" [(ngModel)]="po.purchaseOrder.poNumber"
                                        [disabled]="!po.purchaseOrder.po" pInputText name="poNumber{{i}}" title=" "
                                        required />
                                    <label for="poNumber">PO Number
                                        <span class="required">*</span>
                                    </label>
                                </span>
                            </div>
                            <div class="ui-g-1 padding-0">
                                <span class="ui-float-label">
                                    <p-calendar [inputStyle]="{'width':'90%'}" #poDate="ngModel" id="poDate" name="poDate{{i}}"
                                        [disabled]="!po.purchaseOrder.po" showIcon="true" [utc]="true" [(ngModel)]="po.purchaseOrder.poDate"
                                        dateFormat="ddMy" trim="blur" monthNavigator="true" yearNavigator="true"
                                        [yearRange]="'2017:2050'" required appendTo="body"></p-calendar>
                                    <label for="endDate">PO Date
                                        <span class="required">*</span>
                                    </label>
                                </span>
                            </div> -->
                            <div class="ui-g padding-top-10">
                                <div class="ui-g-12 padding-left-0">
                                    <p-progressBar [value]="files[i].progress"></p-progressBar>
                                </div>
                            </div>
                            <!-- <div class="ui-g-3 margin-top-3 padding-left-20">
                                <p-progressBar [value]="files[i].progress"></p-progressBar>
                            </div> -->
                            <!-- <div class="ui-g-1 margin-top--7">
                                <span class="margin-left-10">
                                    <i class="fa fa-upload" title="Upload the file" aria-hidden="true" (click)="uploadPO(i)"></i>
                                </span>
                                <span class="padding-left-10">
                                    <i class="fa fa-trash-o info-red" title="Remove the file" aria-hidden="true"
                                        (click)="removeFile(i)"></i>
                                </span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </form>
            <!-- </fieldset> -->
        </div>

        <div class="ctext-center padding-10">
            <button class="mtab-primary margin-hori-5 " type="button" pButton label=" UPLOAD ALL "
                (click)="uploadAllPO()"
                [disabled]="!uploadPoForm.form.valid || purchaseOrdersWrapper.length === 0"></button>
            <button class="mtab-save" type="button" pButton label=" SAVE " (click)="saveItems()"
                [disabled]="!uploadPoForm.form.valid || purchaseOrdersWrapper.length === 0 || disableSave"></button>
            <!-- <button class="mtab-secondary" type="button" pButton label=" CANCEL " (click)="hideUploadPODialog()"></button> -->
        </div>

    </p-dialog>
</div>